import {booleanAttribute, ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';

/**
 * Design 2.0 generic modal shell.
 *
 * Mount inside a MatDialog using `panelClass: 'v2-modal-panel'` and
 * `backdropClass: 'v2-modal-backdrop'` (both global styles in `styles.scss`)
 * so the default MatDialog chrome is stripped and the page is dimmed.
 *
 * Example:
 * ```html
 * <app-v2-modal
 *   title="Stroški"
 *   subtitle="Dodaj strošek vozila"
 *   (close)="dialogRef.close()">
 *   <div slot="body">…form…</div>
 *   <div slot="footer">…buttons…</div>
 * </app-v2-modal>
 * ```
 */
@Component({
  selector: 'app-v2-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './v2-modal.component.html',
  styleUrls: ['./v2-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class V2ModalComponent {
  @Input({required: true}) title!: string;
  @Input() subtitle: string | null = null;
  /** Max-content width. Defaults to 440px; use 'lg' / 'xl' / '2xl' for larger
   *  forms or wide table dialogs (e.g. Zgodovina vozila with 8 columns). */
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | '2xl' = 'md';
  @Input({transform: booleanAttribute}) hideClose = false;

  @Output() closeClick = new EventEmitter<void>();
}
